import { Container, Modal } from 'react-bootstrap';
import { PreferentialTooltip } from '../ProductInfo/Tooltips';
import IpaffsModaltable from '../Modals/IpaffsModal/IpaffsModalTable';
import DataTable from '../../DataTable';
import { useEffect, useState } from 'react';

const OrderFormMultiRulesModal = ({ show, onHide, modalData = [], fillOrderForms }) => {
  const [dataTableData, setDataTableData] = useState([]);

  useEffect(() => {
    if (modalData.length) {
      setDataTableData(formatDataForDataTable());
    }
  }, [modalData]);

  const dataTableTextColumn = (key, header, sendAs, tooltip = '', fieldType = 'text') => {
    return (
      <DataTable.Column
        centraliseHeader={true}
        colKey={key}
        key={key}
        header={header}
        searchOpts={{ type: fieldType, sendAs: sendAs }}
        tooltip={
          tooltip && (
            <PreferentialTooltip>
              <p>{tooltip}</p>
            </PreferentialTooltip>
          )
        }
      >
        {(item) => {
          return (
            <>
              {item?.[key] ? (
                <div
                  className="green_tick_box"
                  style={{
                    width: '1.5rem',
                    height: '1.5rem',
                    justifySelf: 'center',
                  }}
                ></div>
              ) : (
                ''
              )}
            </>
          );
        }}
      </DataTable.Column>
    );
  };

  const handleManualSubmit = () => {
    //set all values in Docs to checked = false and return to fillOrderForms
    const data = modalData[0].Docs.map((e) => {
      e.checked = false;
      e.orderFormId = null;
      return e;
    });
    fillOrderForms(data);
    onHide(); // Close the modal after manual submit
  };

  const setOrderFormRule = (item) => {
    const data = modalData.filter((e) => e.orderFormId === item.orderFormId)[0].Docs;
    fillOrderForms(data);
    onHide();
  };

  const formatDataForDataTable = () => {
    if (!modalData) return [];
    else {
      return modalData.map(({ Docs, ...rest }) => rest);
    }
  };

  const renderColumns = () => {
    if (dataTableData?.[0]) {
      return (
        <>
          {Object.keys(dataTableData?.[0]).map(
            (key) => key !== 'orderFormId' && dataTableTextColumn(key, key, key, '')
          )}
          <DataTable.Column header="Rule" style={{ height: '1px', padding: 0 }}>
            {(item) => (
              <button
                style={{ width: '100%' }}
                onClick={() => {
                  setOrderFormRule(item);
                }}
              >
                Apply
              </button>
            )}
          </DataTable.Column>
        </>
      );
    } else return null;
  };

  return (
    <Modal show={show} onHide={handleManualSubmit} centered animation={false} dialogClassName="modal-90w">
      <Modal.Header style={{ display: 'block' }}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'auto auto',
            justifyContent: 'left',
            columnGap: '100px',
          }}
        >
          <Modal.Title
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
            }}
          >
            Multiple Matching Order Form Rules Found{' '}
          </Modal.Title>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'auto auto',
              alignItems: 'center',
              columnGap: '5px',
              borderRadius: '5px',
              padding: '6px',
              fontWeight: 'bold',
              justifyContent: 'space-between',
              height: '85%',
            }}
          >
            <p className="me-2 mb-0">Why am I seeing this?</p>
            <PreferentialTooltip optionalSize="1.5rem">
              <p>
                {
                  "You're seeing this because your Order Form contains values that match multiple rules in the uploaded logic table. These rules determine which fields will be toggled on."
                }
              </p>
            </PreferentialTooltip>
          </div>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Container fluid>
          <p>
            Your order form header matches more than one logic rule. Please select a rule to apply, or proceed manually.
          </p>
          <IpaffsModaltable data={dataTableData || []}>
            {!!dataTableData?.[0] &&
              Object.keys(dataTableData?.[0]).map(
                (key) => key !== 'orderFormId' && dataTableTextColumn(key, key, key, '')
              )}
            <DataTable.Column header="Rule" style={{ height: '1px', padding: 0 }}>
              {(item) => (
                <button
                  style={{ width: '100%' }}
                  onClick={() => {
                    setOrderFormRule(item);
                  }}
                >
                  Apply
                </button>
              )}
            </DataTable.Column>
          </IpaffsModaltable>
        </Container>
      </Modal.Body>
      <Modal.Footer
        className="d-flex flex-row p-3 gap-3 border-top bg-light right align-items-center"
        style={{
          borderBottomLeftRadius: '20px',
          borderBottomRightRadius: '20px',
        }}
      >
        <button
          type="button"
          id="confirm"
          className="blue-button-teams text-nowrap"
          style={{ borderRadius: '10px', minWidth: '250px' }}
          onClick={() => handleManualSubmit()}
        >
          Manually Update Order Form
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default OrderFormMultiRulesModal;
